<template>
  <!-- This component doesn't need hydration, so we don't pass any params -->
  <LazyHydrate>
    <StandardWrapper
      v-bind="$attrs"
      :blok="blok"
      no-section
      :width="blok.width"
      no-padding
    >
      <div>
        <div>
          <component
            :is="blok.heading"
            class="title leading-normal"
            :class="
              textColorClass(blok.titleVariant, blok.bgVariant, 'text-darker')
            "
          >
            {{ blok.title }}
          </component>
        </div>
      </div>
    </StandardWrapper>
  </LazyHydrate>
</template>

<script setup>
import StandardWrapper from '../components/StandardWrapper.vue'
import { useColorPalette } from '../composables/colorPalette'

defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass } = useColorPalette()
</script>
